import { Fragment } from "react";
import Head from "next/head";
import getConfig from "next/config";
import withRouterPageLayout from "@components/withRouterPageLayout.js";

import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";
import { content } from "@lib/aboutUsContent";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const AboutUs = () => {
  return (
    <>
      <Head>
        <title>Despre noi</title>
      </Head>
      <Breadcrumbs
        breadcrumbs={[
          {
            id: 1,
            level: 99,
            name: "Despre noi",
          },
        ]}
      />
      <Heading
        as="h2"
        display="h1"
        title={content[settings.websiteName].title}
        classesProp="mt-6"
      />
      <picture>
        {content[settings.websiteName].image.map((img) => (
          <Fragment key={img.path}>
            {!img.isDefault ? (
              <source srcSet={img.path} media={img.media} />
            ) : (
              <img
                className="w-full my-8 lg:mt-42px lg:mb-77px"
                alt="Altex, 30 de ani alaturi de clientii si partenerii nostri"
                src={img.path}
              />
            )}
          </Fragment>
        ))}
      </picture>
      <article className="columns-2 gap-[30px] md:gap-[105px] leading-relaxed lg:w-3/4 mx-auto">
        {content[settings.websiteName].content}
      </article>
    </>
  );
};

AboutUs.pageLayout = "default";

export default withRouterPageLayout(AboutUs);
